export default __webpack_public_path__ + "static/bryansk-06d71e1897a1208eee7107398ad7efe5.jpg";